var map;
var geocoder;

function initMap() {
	geocoder = new google.maps.Geocoder();
	var map_center = {lat: $('#map').data('center-lat'), lng: $('#map').data('center-lng')};
	var styles = [
		{
			featureType: 'poi',
			stylers: [{visibility: 'off'}]
		},
		{
			featureType: 'transit',
			elementType: 'labels.icon',
			stylers: [{visibility: 'off'}]
		}
	];

	map = new google.maps.Map(document.getElementById('map'), {
		center: map_center,
		zoom: 14,
		styles: styles
	});

	geocoder.geocode({'address': $('#map').data('center-address')}, function(results, status) {
		if (status == 'OK') {
			map.setCenter(results[0].geometry.location);
			var marker = new google.maps.Marker({
				map: map,
				title: $('#map').data('center-title'),
				position: results[0].geometry.location
			});
		} else {
			console.log('Geocode was not successful for the following reason: ' + status);
		}
	});
}

handle_svg_resize();
$(window).resize(debounce(handle_svg_resize, 100));

function handle_svg_resize() {
	if (!$('body').hasClass('mode_mobile')) {
		var window_width = $(window).width();

		var gabarit = $('.acces_transport');
		var gabarit_height = gabarit.innerHeight();
		var svg = gabarit.find('.svg_blob').first();
		var svg_viewbox_array = svg[0].getAttribute('viewBox').split(' ');
		var svg_ratio = svg_viewbox_array[2] / svg_viewbox_array[3];
		var svg_width = gabarit_height * svg_ratio;
		var decalage = (svg_width - window_width) / 2;
		if (decalage > 0) {
			decalage *= -1;
		}
		svg.css({'width': svg_width + 'px', 'left': decalage + 'px', 'right': decalage + 'px'});
	}
}
